import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRouteStudent = ({ children }) => {
  const { studentUser } = useAuth();

  if (!studentUser) {
    return <Navigate to="/student-login" replace />;
  }

  return children;
};

export default ProtectedRouteStudent;
